<h1 mat-dialog-title>Cancelar pedido</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 700px;">
  <div class="row mt-4">
    <div class="col-sm">
      <h1 style="color: gray">Deseja realmente cancelar o boleto deste pedido?</h1>
    </div>
  </div>

  <mat-divider></mat-divider>

  <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
    <button mat-flat-button color="warn" (click)="cancelar()">
      <mat-icon>clear</mat-icon> Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="confirmarCancelamento()">
      <mat-icon>check</mat-icon> Confirmar cancelamento
    </button>
  </section>
</div>
